import type { ReactNode } from 'react'

import {
  Cancel01Icon,
  GridViewIcon,
  LockIcon,
  StarIcon,
  Tick02Icon
} from '@hugeicons/react'
import { FireIcon } from '@hugeicons/react'

import type { FilterChipOption } from '@/shared/ui/Layout/page/FilterChips'

import { PRIZE_FILTERS, type PrizeFilterId } from '../constants/status'

const PRIZE_FILTER_ICONS: Partial<Record<PrizeFilterId, ReactNode>> = {
  all: <GridViewIcon size={12} variant="stroke" aria-hidden />,
  progress: (
    <FireIcon size={12} variant="stroke" style={{ color: 'var(--color-brand)' }} aria-hidden />
  ),
  available: (
    <StarIcon size={12} variant="duotone" style={{ color: 'var(--color-brand)' }} aria-hidden />
  ),
  locked: (
    <LockIcon size={12} variant="stroke" style={{ color: 'var(--gami-badge-locked-bg)' }} aria-hidden />
  ),
  expired: (
    <Cancel01Icon size={12} variant="stroke" style={{ color: 'var(--gami-badge-expired-bg)' }} aria-hidden />
  ),
  success: (
    <Tick02Icon size={12} variant="stroke" style={{ color: 'var(--gami-badge-success-bg)' }} aria-hidden />
  )
}

export const PRIZE_FILTER_OPTIONS: FilterChipOption<PrizeFilterId>[] =
  PRIZE_FILTERS.map(filter => ({
    ...filter,
    icon: PRIZE_FILTER_ICONS[filter.id]
  }))
